import { cssColorValue, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
var border = "1px solid ".concat(cssColorValue(semanticColors.decorativeSubdued));
export var Item = styled.li.withConfig({
  displayName: "Item",
  componentId: "sc-jzntl3-0"
})(["", ";list-style-type:none;border-block-start:", ";border-inline-end:", ";border-inline-start:", ";&:last-child{border-block-end:", ";}"], rootStyle(), border, border, border, border);